module.exports = __webpack_public_path__ + "img/activity-banner-1.dbaeea17.png";